import { z } from "zod";

export const COUNTRY_REGION_ENUM = z.enum([
  "all",
  "africa",
  "asia",
  "europe",
  "north_america",
  "south_america",
  "oceania",
  "middle_east",
  "caribbean",
  "eu_citizens",
  "commonwealth",
  "developing_countries"
]);

export const COUNTRY_NAMES = {
  "AF": "Afghanistan",
  "AX": "Åland Islands",
  "AL": "Albania",
  "DZ": "Algeria",
  "AS": "American Samoa",
  "AD": "Andorra",
  "AO": "Angola",
  "AI": "Anguilla",
  "AQ": "Antarctica",
  "AG": "Antigua and Barbuda",
  "AR": "Argentina",
  "AM": "Armenia",
  "AW": "Aruba",
  "AU": "Australia",
  "AT": "Austria",
  "AZ": "Azerbaijan",
  "BS": "Bahamas",
  "BH": "Bahrain",
  "BD": "Bangladesh",
  "BB": "Barbados",
  "BY": "Belarus",
  "BE": "Belgium",
  "BZ": "Belize",
  "BJ": "Benin",
  "BM": "Bermuda",
  "BT": "Bhutan",
  "BO": "Bolivia",
  "BQ": "Caribbean Netherlands",
  "BA": "Bosnia and Herzegovina",
  "BW": "Botswana",
  "BV": "Bouvet Island",
  "BR": "Brazil",
  "IO": "British Indian Ocean Territory",
  "BN": "Brunei",
  "BG": "Bulgaria",
  "BF": "Burkina Faso",
  "BI": "Burundi",
  "CV": "Cape Verde",
  "KH": "Cambodia",
  "CM": "Cameroon",
  "CA": "Canada",
  "KY": "Cayman Islands",
  "CF": "Central African Republic",
  "TD": "Chad",
  "CL": "Chile",
  "CN": "China",
  "CX": "Christmas Island",
  "CC": "Cocos Islands",
  "CO": "Colombia",
  "KM": "Comoros",
  "CG": "Congo",
  "CD": "DR Congo",
  "CK": "Cook Islands",
  "CR": "Costa Rica",
  "CI": "Côte d'Ivoire",
  "HR": "Croatia",
  "CU": "Cuba",
  "CW": "Curaçao",
  "CY": "Cyprus",
  "CZ": "Czech Republic",
  "DK": "Denmark",
  "DJ": "Djibouti",
  "DM": "Dominica",
  "DO": "Dominican Republic",
  "EC": "Ecuador",
  "EG": "Egypt",
  "SV": "El Salvador",
  "GQ": "Equatorial Guinea",
  "ER": "Eritrea",
  "EE": "Estonia",
  "SZ": "Eswatini",
  "ET": "Ethiopia",
  "FK": "Falkland Islands",
  "FO": "Faroe Islands",
  "FJ": "Fiji",
  "FI": "Finland",
  "FR": "France",
  "GF": "French Guiana",
  "PF": "French Polynesia",
  "TF": "French Southern Territories",
  "GA": "Gabon",
  "GM": "Gambia",
  "GE": "Georgia",
  "DE": "Germany",
  "GH": "Ghana",
  "GI": "Gibraltar",
  "GR": "Greece",
  "GL": "Greenland",
  "GD": "Grenada",
  "GP": "Guadeloupe",
  "GU": "Guam",
  "GT": "Guatemala",
  "GG": "Guernsey",
  "GN": "Guinea",
  "GW": "Guinea-Bissau",
  "GY": "Guyana",
  "HT": "Haiti",
  "HM": "Heard and McDonald Islands",
  "VA": "Vatican City",
  "HN": "Honduras",
  "HK": "Hong Kong",
  "HU": "Hungary",
  "IS": "Iceland",
  "IN": "India",
  "ID": "Indonesia",
  "IR": "Iran",
  "IQ": "Iraq",
  "IE": "Ireland",
  "IM": "Isle of Man",
  "IL": "Israel",
  "IT": "Italy",
  "JM": "Jamaica",
  "JP": "Japan",
  "JE": "Jersey",
  "JO": "Jordan",
  "KZ": "Kazakhstan",
  "KE": "Kenya",
  "KI": "Kiribati",
  "KP": "North Korea",
  "KR": "South Korea",
  "KW": "Kuwait",
  "KG": "Kyrgyzstan",
  "LA": "Laos",
  "LV": "Latvia",
  "LB": "Lebanon",
  "LS": "Lesotho",
  "LR": "Liberia",
  "LY": "Libya",
  "LI": "Liechtenstein",
  "LT": "Lithuania",
  "LU": "Luxembourg",
  "MO": "Macau",
  "MG": "Madagascar",
  "MW": "Malawi",
  "MY": "Malaysia",
  "MV": "Maldives",
  "ML": "Mali",
  "MT": "Malta",
  "MH": "Marshall Islands",
  "MQ": "Martinique",
  "MR": "Mauritania",
  "MU": "Mauritius",
  "YT": "Mayotte",
  "MX": "Mexico",
  "FM": "Micronesia",
  "MD": "Moldova",
  "MC": "Monaco",
  "MN": "Mongolia",
  "ME": "Montenegro",
  "MS": "Montserrat",
  "MA": "Morocco",
  "MZ": "Mozambique",
  "MM": "Myanmar",
  "NA": "Namibia",
  "NR": "Nauru",
  "NP": "Nepal",
  "NL": "Netherlands",
  "NC": "New Caledonia",
  "NZ": "New Zealand",
  "NI": "Nicaragua",
  "NE": "Niger",
  "NG": "Nigeria",
  "NU": "Niue",
  "NF": "Norfolk Island",
  "MK": "North Macedonia",
  "MP": "Northern Mariana Islands",
  "NO": "Norway",
  "OM": "Oman",
  "PK": "Pakistan",
  "PW": "Palau",
  "PS": "Palestine",
  "PA": "Panama",
  "PG": "Papua New Guinea",
  "PY": "Paraguay",
  "PE": "Peru",
  "PH": "Philippines",
  "PN": "Pitcairn Islands",
  "PL": "Poland",
  "PT": "Portugal",
  "PR": "Puerto Rico",
  "QA": "Qatar",
  "RE": "Réunion",
  "RO": "Romania",
  "RU": "Russia",
  "RW": "Rwanda",
  "BL": "Saint Barthélemy",
  "SH": "Saint Helena",
  "KN": "Saint Kitts and Nevis",
  "LC": "Saint Lucia",
  "MF": "Saint Martin",
  "PM": "Saint Pierre and Miquelon",
  "VC": "Saint Vincent and the Grenadines",
  "WS": "Samoa",
  "SM": "San Marino",
  "ST": "São Tomé and Príncipe",
  "SA": "Saudi Arabia",
  "SN": "Senegal",
  "RS": "Serbia",
  "SC": "Seychelles",
  "SL": "Sierra Leone",
  "SG": "Singapore",
  "SX": "Sint Maarten",
  "SK": "Slovakia",
  "SI": "Slovenia",
  "SB": "Solomon Islands",
  "SO": "Somalia",
  "ZA": "South Africa",
  "GS": "South Georgia and the South Sandwich Islands",
  "SS": "South Sudan",
  "ES": "Spain",
  "LK": "Sri Lanka",
  "SD": "Sudan",
  "SR": "Suriname",
  "SJ": "Svalbard and Jan Mayen",
  "SE": "Sweden",
  "CH": "Switzerland",
  "SY": "Syria",
  "TW": "Taiwan",
  "TJ": "Tajikistan",
  "TZ": "Tanzania",
  "TH": "Thailand",
  "TL": "Timor-Leste",
  "TG": "Togo",
  "TK": "Tokelau",
  "TO": "Tonga",
  "TT": "Trinidad and Tobago",
  "TN": "Tunisia",
  "TR": "Türkiye",
  "TM": "Turkmenistan",
  "TC": "Turks and Caicos Islands",
  "TV": "Tuvalu",
  "UG": "Uganda",
  "UA": "Ukraine",
  "AE": "United Arab Emirates",
  "GB": "United Kingdom",
  "US": "United States",
  "UM": "U.S. Outlying Islands",
  "UY": "Uruguay",
  "UZ": "Uzbekistan",
  "VU": "Vanuatu",
  "VE": "Venezuela",
  "VN": "Vietnam",
  "VG": "British Virgin Islands",
  "VI": "U.S. Virgin Islands",
  "WF": "Wallis and Futuna",
  "EH": "Western Sahara",
  "YE": "Yemen",
  "ZM": "Zambia",
  "ZW": "Zimbabwe"
};

export const COUNTRY_PHONE_CODES = { "BD": "880", "BE": "32", "BF": "226", "BG": "359", "BA": "387", "BB": "1246", "WF": "681", "BL": "590", "BM": "1441", "BN": "673", "BO": "591", "BH": "973", "BI": "257", "BJ": "229", "BT": "975", "JM": "1876", "BV": "", "BW": "267", "WS": "685", "BQ": "599", "BR": "55", "BS": "1242", "JE": "44-1534", "BY": "375", "BZ": "501", "RU": "7", "RW": "250", "RS": "381", "TL": "670", "RE": "262", "TM": "993", "TJ": "992", "RO": "40", "TK": "690", "GW": "245", "GU": "1671", "GT": "502", "GS": "", "GR": "30", "GQ": "240", "GP": "590", "JP": "81", "GY": "592", "GG": "44-1481", "GF": "594", "GE": "995", "GD": "1473", "GB": "44", "GA": "241", "SV": "503", "GN": "224", "GM": "220", "GL": "299", "GI": "350", "GH": "233", "OM": "968", "TN": "216", "JO": "962", "HR": "385", "HT": "509", "HU": "36", "HK": "852", "HN": "504", "HM": " ", "VE": "58", "PR": "1787 and 1-939", "PS": "970", "PW": "680", "PT": "351", "SJ": "47", "PY": "595", "IQ": "964", "PA": "507", "PF": "689", "PG": "675", "PE": "51", "PK": "92", "PH": "63", "PN": "870", "PL": "48", "PM": "508", "ZM": "260", "EH": "212", "EE": "372", "EG": "20", "ZA": "27", "EC": "593", "IT": "39", "VN": "84", "SB": "677", "ET": "251", "SO": "252", "ZW": "263", "SA": "966", "ES": "34", "ER": "291", "ME": "382", "MD": "373", "MG": "261", "MF": "590", "MA": "212", "MC": "377", "UZ": "998", "MM": "95", "ML": "223", "MO": "853", "MN": "976", "MH": "692", "MK": "389", "MU": "230", "MT": "356", "MW": "265", "MV": "960", "MQ": "596", "MP": "1670", "MS": "1664", "MR": "222", "IM": "44-1624", "UG": "256", "TZ": "255", "MY": "60", "MX": "52", "IL": "972", "FR": "33", "IO": "246", "SH": "290", "FI": "358", "FJ": "679", "FK": "500", "FM": "691", "FO": "298", "NI": "505", "NL": "31", "NO": "47", "NA": "264", "VU": "678", "NC": "687", "NE": "227", "NF": "672", "NG": "234", "NZ": "64", "NP": "977", "NR": "674", "NU": "683", "CK": "682", "XK": "", "CI": "225", "CH": "41", "CO": "57", "CN": "86", "CM": "237", "CL": "56", "CC": "61", "CA": "1", "CG": "242", "CF": "236", "CD": "243", "CZ": "420", "CY": "357", "CX": "61", "CR": "506", "CW": "599", "CV": "238", "CU": "53", "SZ": "268", "SY": "963", "SX": "599", "KG": "996", "KE": "254", "SS": "211", "SR": "597", "KI": "686", "KH": "855", "KN": "1869", "KM": "269", "ST": "239", "SK": "421", "KR": "82", "SI": "386", "KP": "850", "KW": "965", "SN": "221", "SM": "378", "SL": "232", "SC": "248", "KZ": "7", "KY": "1345", "SG": "65", "SE": "46", "SD": "249", "DO": "1809 and 1-829", "DM": "1767", "DJ": "253", "DK": "45", "VG": "1284", "DE": "49", "YE": "967", "DZ": "213", "US": "1", "UY": "598", "YT": "262", "UM": "1", "LB": "961", "LC": "1758", "LA": "856", "TV": "688", "TW": "886", "TT": "1868", "TR": "90", "LK": "94", "LI": "423", "LV": "371", "TO": "676", "LT": "370", "LU": "352", "LR": "231", "LS": "266", "TH": "66", "TF": "", "TG": "228", "TD": "235", "TC": "1649", "LY": "218", "VA": "379", "VC": "1784", "AE": "971", "AD": "376", "AG": "1268", "AF": "93", "AI": "1264", "VI": "1340", "IS": "354", "IR": "98", "AM": "374", "AL": "355", "AO": "244", "AQ": "", "AS": "1684", "AR": "54", "AU": "61", "AT": "43", "AW": "297", "IN": "91", "AX": "358-18", "AZ": "994", "IE": "353", "ID": "62", "UA": "380", "QA": "974", "MZ": "258" };

const countryPhoneCodeInversed = Object.fromEntries(Object.entries(COUNTRY_PHONE_CODES).map(([alphaCode, dialCode]) => [dialCode, alphaCode]));

export type COUNTRY_REGION_ENUM_TYPE = z.infer<typeof COUNTRY_REGION_ENUM>;

export const COUNTRY_TO_REGION_MAP: Record<string, COUNTRY_REGION_ENUM_TYPE[]> = {
  // AFRICA (54 countries)
  'dz': ['africa', 'developing_countries'], // Algeria
  'ao': ['africa', 'developing_countries'], // Angola
  'bj': ['africa', 'developing_countries'], // Benin
  'bw': ['africa', 'developing_countries'], // Botswana
  'bf': ['africa', 'developing_countries'], // Burkina Faso
  'bi': ['africa', 'developing_countries'], // Burundi
  'cv': ['africa', 'developing_countries'], // Cape Verde
  'cm': ['africa', 'developing_countries'], // Cameroon
  'cf': ['africa', 'developing_countries'], // Central African Republic
  'td': ['africa', 'developing_countries'], // Chad
  'km': ['africa', 'developing_countries'], // Comoros
  'cg': ['africa', 'developing_countries'], // Congo
  'cd': ['africa', 'developing_countries'], // Congo, Democratic Republic
  'ci': ['africa', 'developing_countries'], // Cote d'Ivoire
  'dj': ['africa', 'developing_countries'], // Djibouti
  'eg': ['africa', 'developing_countries'], // Egypt
  'gq': ['africa', 'developing_countries'], // Equatorial Guinea
  'er': ['africa', 'developing_countries'], // Eritrea
  'sz': ['africa', 'developing_countries'], // Eswatini
  'et': ['africa', 'developing_countries'], // Ethiopia
  'ga': ['africa', 'developing_countries'], // Gabon
  'gm': ['africa', 'developing_countries'], // Gambia
  'gh': ['africa', 'developing_countries', 'commonwealth'], // Ghana
  'gn': ['africa', 'developing_countries'], // Guinea
  'gw': ['africa', 'developing_countries'], // Guinea-Bissau
  'ke': ['africa', 'developing_countries', 'commonwealth'], // Kenya
  'ls': ['africa', 'developing_countries', 'commonwealth'], // Lesotho
  'lr': ['africa', 'developing_countries'], // Liberia
  'ly': ['africa', 'developing_countries'], // Libya
  'mg': ['africa', 'developing_countries'], // Madagascar
  'mw': ['africa', 'developing_countries', 'commonwealth'], // Malawi
  'ml': ['africa', 'developing_countries'], // Mali
  'mr': ['africa', 'developing_countries'], // Mauritania
  'mu': ['africa', 'developing_countries', 'commonwealth'], // Mauritius
  'ma': ['africa', 'developing_countries'], // Morocco
  'mz': ['africa', 'developing_countries', 'commonwealth'], // Mozambique
  'na': ['africa', 'developing_countries', 'commonwealth'], // Namibia
  'ne': ['africa', 'developing_countries'], // Niger
  'ng': ['africa', 'developing_countries', 'commonwealth'], // Nigeria
  'rw': ['africa', 'developing_countries', 'commonwealth'], // Rwanda
  'st': ['africa', 'developing_countries'], // Sao Tome and Principe
  'sn': ['africa', 'developing_countries'], // Senegal
  'sc': ['africa', 'developing_countries', 'commonwealth'], // Seychelles
  'sl': ['africa', 'developing_countries', 'commonwealth'], // Sierra Leone
  'so': ['africa', 'developing_countries'], // Somalia
  'za': ['africa', 'developing_countries', 'commonwealth'], // South Africa
  'ss': ['africa', 'developing_countries'], // South Sudan
  'sd': ['africa', 'developing_countries'], // Sudan
  'tz': ['africa', 'developing_countries', 'commonwealth'], // Tanzania
  'tg': ['africa', 'developing_countries'], // Togo
  'tn': ['africa', 'developing_countries'], // Tunisia
  'ug': ['africa', 'developing_countries', 'commonwealth'], // Uganda
  'zm': ['africa', 'developing_countries', 'commonwealth'], // Zambia
  'zw': ['africa', 'developing_countries', 'commonwealth'], // Zimbabwe

  // ASIA (48 countries)
  'af': ['asia', 'developing_countries'], // Afghanistan
  'am': ['asia'], // Armenia
  'az': ['asia'], // Azerbaijan
  'bh': ['asia', 'middle_east'], // Bahrain
  'bd': ['asia', 'developing_countries', 'commonwealth'], // Bangladesh
  'bt': ['asia', 'developing_countries'], // Bhutan
  'bn': ['asia', 'commonwealth'], // Brunei
  'kh': ['asia', 'developing_countries'], // Cambodia
  'cn': ['asia'], // China
  'cy': ['asia', 'eu_citizens', 'commonwealth'], // Cyprus
  'ge': ['asia'], // Georgia
  'in': ['asia', 'developing_countries', 'commonwealth'], // India
  'id': ['asia', 'developing_countries'], // Indonesia
  'ir': ['asia', 'developing_countries'], // Iran
  'iq': ['asia', 'developing_countries'], // Iraq
  'il': ['asia'], // Israel
  'jp': ['asia'], // Japan
  'jo': ['asia', 'developing_countries'], // Jordan
  'kz': ['asia'], // Kazakhstan
  'kw': ['asia', 'middle_east'], // Kuwait
  'kg': ['asia', 'developing_countries'], // Kyrgyzstan
  'la': ['asia', 'developing_countries'], // Laos
  'lb': ['asia', 'developing_countries'], // Lebanon
  'my': ['asia', 'developing_countries', 'commonwealth'], // Malaysia
  'mv': ['asia', 'developing_countries', 'commonwealth'], // Maldives
  'mn': ['asia', 'developing_countries'], // Mongolia
  'mm': ['asia', 'developing_countries'], // Myanmar
  'np': ['asia', 'developing_countries'], // Nepal
  'kp': ['asia', 'developing_countries'], // North Korea
  'om': ['asia', 'middle_east'], // Oman
  'pk': ['asia', 'developing_countries', 'commonwealth'], // Pakistan
  'ps': ['asia', 'developing_countries'], // Palestine
  'ph': ['asia', 'developing_countries'], // Philippines
  'qa': ['asia', 'middle_east'], // Qatar
  'sa': ['asia', 'middle_east'], // Saudi Arabia
  'sg': ['asia', 'commonwealth'], // Singapore
  'kr': ['asia'], // South Korea
  'lk': ['asia', 'developing_countries', 'commonwealth'], // Sri Lanka
  'sy': ['asia', 'developing_countries'], // Syria
  'tj': ['asia', 'developing_countries'], // Tajikistan
  'th': ['asia', 'developing_countries'], // Thailand
  'tl': ['asia', 'developing_countries'], // Timor-Leste
  'tr': ['asia'], // Turkey
  'tm': ['asia'], // Turkmenistan
  'ae': ['asia', 'middle_east'], // UAE
  'uz': ['asia', 'developing_countries'], // Uzbekistan
  'vn': ['asia', 'developing_countries'], // Vietnam
  'ye': ['asia', 'developing_countries'], // Yemen

  // EUROPE (44 countries)
  'ad': ['europe'], // Andorra
  'al': ['europe'], // Albania
  'at': ['europe', 'eu_citizens'], // Austria
  'by': ['europe'], // Belarus
  'be': ['europe', 'eu_citizens'], // Belgium
  'ba': ['europe'], // Bosnia and Herzegovina
  'bg': ['europe', 'eu_citizens'], // Bulgaria
  'hr': ['europe', 'eu_citizens'], // Croatia
  'cz': ['europe', 'eu_citizens'], // Czech Republic
  'dk': ['europe', 'eu_citizens'], // Denmark
  'ee': ['europe', 'eu_citizens'], // Estonia
  'fi': ['europe', 'eu_citizens'], // Finland
  'fr': ['europe', 'eu_citizens'], // France
  'de': ['europe', 'eu_citizens'], // Germany
  'gr': ['europe', 'eu_citizens'], // Greece
  'hu': ['europe', 'eu_citizens'], // Hungary
  'is': ['europe'], // Iceland
  'ie': ['europe', 'eu_citizens'], // Ireland
  'it': ['europe', 'eu_citizens'], // Italy
  'xk': ['europe'], // Kosovo
  'lv': ['europe', 'eu_citizens'], // Latvia
  'li': ['europe'], // Liechtenstein
  'lt': ['europe', 'eu_citizens'], // Lithuania
  'lu': ['europe', 'eu_citizens'], // Luxembourg
  'mt': ['europe', 'eu_citizens', 'commonwealth'], // Malta
  'md': ['europe'], // Moldova
  'mc': ['europe'], // Monaco
  'me': ['europe'], // Montenegro
  'nl': ['europe', 'eu_citizens'], // Netherlands
  'mk': ['europe'], // North Macedonia
  'no': ['europe'], // Norway
  'pl': ['europe', 'eu_citizens'], // Poland
  'pt': ['europe', 'eu_citizens'], // Portugal
  'ro': ['europe', 'eu_citizens'], // Romania
  'ru': ['europe'], // Russia
  'sm': ['europe'], // San Marino
  'rs': ['europe'], // Serbia
  'sk': ['europe', 'eu_citizens'], // Slovakia
  'si': ['europe', 'eu_citizens'], // Slovenia
  'es': ['europe', 'eu_citizens'], // Spain
  'se': ['europe', 'eu_citizens'], // Sweden
  'ch': ['europe'], // Switzerland
  'ua': ['europe'], // Ukraine
  'gb': ['europe', 'commonwealth'], // United Kingdom
  'va': ['europe'], // Vatican City

  // NORTH AMERICA (3 countries)
  'ca': ['north_america', 'commonwealth'], // Canada
  'mx': ['north_america', 'developing_countries'], // Mexico
  'us': ['north_america'], // United States

  // SOUTH AMERICA (12 countries)
  'ar': ['south_america', 'developing_countries'], // Argentina
  'bo': ['south_america', 'developing_countries'], // Bolivia
  'br': ['south_america', 'developing_countries'], // Brazil
  'cl': ['south_america', 'developing_countries'], // Chile
  'co': ['south_america', 'developing_countries'], // Colombia
  'ec': ['south_america', 'developing_countries'], // Ecuador
  'gy': ['south_america', 'developing_countries', 'commonwealth'], // Guyana
  'py': ['south_america', 'developing_countries'], // Paraguay
  'pe': ['south_america', 'developing_countries'], // Peru
  'sr': ['south_america', 'developing_countries'], // Suriname
  'uy': ['south_america', 'developing_countries'], // Uruguay
  've': ['south_america', 'developing_countries'], // Venezuela

  // OCEANIA (14 countries)
  'au': ['oceania', 'commonwealth'], // Australia
  'fj': ['oceania', 'developing_countries', 'commonwealth'], // Fiji
  'ki': ['oceania', 'developing_countries', 'commonwealth'], // Kiribati
  'mh': ['oceania', 'developing_countries'], // Marshall Islands
  'fm': ['oceania', 'developing_countries'], // Micronesia
  'nr': ['oceania', 'developing_countries', 'commonwealth'], // Nauru
  'nz': ['oceania', 'commonwealth'], // New Zealand
  'pw': ['oceania', 'developing_countries'], // Palau
  'pg': ['oceania', 'developing_countries', 'commonwealth'], // Papua New Guinea
  'ws': ['oceania', 'developing_countries', 'commonwealth'], // Samoa
  'sb': ['oceania', 'developing_countries', 'commonwealth'], // Solomon Islands
  'to': ['oceania', 'developing_countries', 'commonwealth'], // Tonga
  'tv': ['oceania', 'developing_countries', 'commonwealth'], // Tuvalu
  'vu': ['oceania', 'developing_countries', 'commonwealth'], // Vanuatu

  // CARIBBEAN (13 countries)
  'ag': ['caribbean', 'developing_countries', 'commonwealth'], // Antigua and Barbuda
  'bs': ['caribbean', 'developing_countries', 'commonwealth'], // Bahamas
  'bb': ['caribbean', 'developing_countries', 'commonwealth'], // Barbados
  'bz': ['caribbean', 'developing_countries', 'commonwealth'], // Belize
  'cu': ['caribbean', 'developing_countries'], // Cuba
  'dm': ['caribbean', 'developing_countries', 'commonwealth'], // Dominica
  'do': ['caribbean', 'developing_countries'], // Dominican Republic
  'gd': ['caribbean', 'developing_countries', 'commonwealth'], // Grenada
  'ht': ['caribbean', 'developing_countries'], // Haiti
  'jm': ['caribbean', 'developing_countries', 'commonwealth'], // Jamaica
  'kn': ['caribbean', 'developing_countries', 'commonwealth'], // Saint Kitts and Nevis
  'lc': ['caribbean', 'developing_countries', 'commonwealth'], // Saint Lucia
  'vc': ['caribbean', 'developing_countries', 'commonwealth'], // Saint Vincent and Grenadines
  'tt': ['caribbean', 'developing_countries', 'commonwealth'], // Trinidad and Tobago
};


export const COUNTRY_PHONE_TO_TIMEZONE = {
  "20": "Africa/Cairo",
  "211": "Africa/Juba",
  "212": "Africa/Casablanca",
  "213": "Africa/Algiers",
  "216": "Africa/Tunis",
  "218": "Africa/Tripoli",
  "220": "Africa/Banjul",
  "221": "Africa/Dakar",
  "222": "Africa/Nouakchott",
  "223": "Africa/Bamako",
  "224": "Africa/Conakry",
  "225": "Africa/Abidjan",
  "226": "Africa/Ouagadougou",
  "227": "Africa/Niamey",
  "228": "Africa/Lome",
  "229": "Africa/Porto-Novo",
  "230": "Indian/Mauritius",
  "231": "Africa/Monrovia",
  "232": "Africa/Freetown",
  "233": "Africa/Accra",
  "234": "Africa/Lagos",
  "235": "Africa/Ndjamena",
  "236": "Africa/Bangui",
  "237": "Africa/Douala",
  "238": "Atlantic/Cape_Verde",
  "239": "Africa/Sao_Tome",
  "240": "Africa/Malabo",
  "241": "Africa/Libreville",
  "242": "Africa/Brazzaville",
  "243": "Africa/Kinshasa",
  "244": "Africa/Luanda",
  "245": "Africa/Bissau",
  "246": "Indian/Chagos",
  "247": "Europe/London",
  "248": "Indian/Mahe",
  "249": "Africa/Khartoum",
  "250": "Africa/Kigali",
  "251": "Africa/Addis_Ababa",
  "252": "Africa/Mogadishu",
  "253": "Africa/Djibouti",
  "254": "Africa/Nairobi",
  "255": "Africa/Dar_es_Salaam",
  "256": "Africa/Kampala",
  "257": "Africa/Bujumbura",
  "258": "Africa/Maputo",
  "260": "Africa/Lusaka",
  "261": "Indian/Antananarivo",
  "262": "Indian/Reunion",
  "263": "Africa/Harare",
  "264": "Africa/Windhoek",
  "265": "Africa/Blantyre",
  "266": "Africa/Maseru",
  "267": "Africa/Gaborone",
  "268": "Africa/Mbabane",
  "269": "Indian/Comoro",
  "27": "Africa/Johannesburg",
  "290": "Atlantic/St_Helena",
  "291": "Africa/Asmara",
  "297": "America/Aruba",
  "298": "Atlantic/Faroe",
  "299": "America/Godthab",
  "30": "Europe/Athens",
  "31": "Europe/Amsterdam",
  "32": "Europe/Brussels",
  "33": "Europe/Paris",
  "34": "Europe/Madrid",
  "350": "Europe/Gibraltar",
  "351": "Europe/Lisbon",
  "352": "Europe/Luxembourg",
  "353": "Europe/Dublin",
  "354": "Atlantic/Reykjavik",
  "355": "Europe/Tirane",
  "356": "Europe/Malta",
  "357": "Asia/Nicosia",
  "358": "Europe/Helsinki",
  "359": "Europe/Sofia",
  "36": "Europe/Budapest",
  "370": "Europe/Vilnius",
  "371": "Europe/Riga",
  "372": "Europe/Tallinn",
  "373": "Europe/Chisinau",
  "374": "Asia/Yerevan",
  "375": "Europe/Minsk",
  "376": "Europe/Andorra",
  "377": "Europe/Monaco",
  "378": "Europe/San_Marino",
  "379": "Europe/Vatican",
  "380": "Europe/Kiev",
  "381": "Europe/Belgrade",
  "382": "Europe/Podgorica",
  "385": "Europe/Zagreb",
  "386": "Europe/Ljubljana",
  "387": "Europe/Sarajevo",
  "388": "Europe/London",
  "389": "Europe/Skopje",
  "39": "Europe/Rome",
  "40": "Europe/Bucharest",
  "41": "Europe/Zurich",
  "420": "Europe/Prague",
  "421": "Europe/Bratislava",
  "423": "Europe/Vaduz",
  "43": "Europe/Vienna",
  "44": "Europe/London",
  "45": "Europe/Copenhagen",
  "46": "Europe/Stockholm",
  "47": "Europe/Oslo",
  "48": "Europe/Warsaw",
  "49": "Europe/Berlin",
  "500": "Atlantic/Stanley",
  "501": "America/Belize",
  "502": "America/Guatemala",
  "503": "America/El_Salvador",
  "504": "America/Tegucigalpa",
  "505": "America/Managua",
  "506": "America/Costa_Rica",
  "507": "America/Panama",
  "508": "America/Miquelon",
  "509": "America/Port-au-Prince",
  "51": "America/Lima",
  "52": "America/Mexico_City",
  "53": "America/Havana",
  "54": "America/Argentina/Buenos_Aires",
  "55": "America/Noronha",
  "56": "America/Santiago",
  "57": "America/Bogota",
  "58": "America/Caracas",
  "590": "America/Guadeloupe",
  "591": "America/La_Paz",
  "592": "America/Guyana",
  "593": "America/Guayaquil",
  "594": "America/Cayenne",
  "595": "America/Asuncion",
  "596": "America/Martinique",
  "597": "America/Paramaribo",
  "598": "America/Montevideo",
  "599": "America/Kralendijk",
  "60": "Asia/Kuala_Lumpur",
  "61": "Australia/Lord_Howe",
  "62": "Asia/Jakarta",
  "63": "Asia/Manila",
  "64": "Pacific/Auckland",
  "65": "Asia/Singapore",
  "66": "Asia/Bangkok",
  "670": "Asia/Dili",
  "672": "Pacific/Norfolk",
  "673": "Asia/Brunei",
  "674": "Pacific/Nauru",
  "675": "Pacific/Port_Moresby",
  "676": "Pacific/Tongatapu",
  "677": "Pacific/Guadalcanal",
  "678": "Pacific/Efate",
  "679": "Pacific/Fiji",
  "680": "Pacific/Palau",
  "681": "Pacific/Wallis",
  "682": "Pacific/Rarotonga",
  "683": "Pacific/Niue",
  "685": "Pacific/Apia",
  "686": "Pacific/Tarawa",
  "687": "Pacific/Noumea",
  "688": "Pacific/Funafuti",
  "689": "Pacific/Tahiti",
  "690": "Pacific/Fakaofo",
  "691": "Pacific/Chuuk",
  "692": "Pacific/Majuro",
  "73": "Europe/Kaliningrad",
  "74": "Europe/Kaliningrad",
  "76": "Asia/Almaty",
  "77": "Asia/Almaty",
  "78": "Europe/Kaliningrad",
  "7940": "Europe/Kaliningrad",
  "81": "Asia/Tokyo",
  "82": "Asia/Seoul",
  "84": "Asia/Ho_Chi_Minh",
  "850": "Asia/Pyongyang",
  "852": "Asia/Hong_Kong",
  "853": "Asia/Macau",
  "855": "Asia/Phnom_Penh",
  "856": "Asia/Vientiane",
  "86": "Asia/Shanghai",
  "880": "Asia/Dhaka",
  "886": "Asia/Taipei",
  "90": "Europe/Istanbul",
  "91": "Asia/Kolkata",
  "92": "Asia/Karachi",
  "93": "Asia/Kabul",
  "94": "Asia/Colombo",
  "95": "Asia/Rangoon",
  "960": "Indian/Maldives",
  "961": "Asia/Beirut",
  "962": "Asia/Amman",
  "963": "Asia/Damascus",
  "964": "Asia/Baghdad",
  "965": "Asia/Kuwait",
  "966": "Asia/Riyadh",
  "967": "Asia/Aden",
  "968": "Asia/Muscat",
  "970": "Asia/Gaza",
  "971": "Asia/Dubai",
  "972": "Asia/Jerusalem",
  "973": "Asia/Bahrain",
  "974": "Asia/Qatar",
  "975": "Asia/Thimphu",
  "976": "Asia/Ulaanbaatar",
  "977": "Asia/Kathmandu",
  "98": "Asia/Tehran",
  "992": "Asia/Dushanbe",
  "993": "Asia/Ashgabat",
  "994": "Asia/Baku",
  "995": "Asia/Tbilisi",
  "996": "Asia/Bishkek",
  "998": "Asia/Samarkand",
}

export const US_AREA_CODE_TIMEZONES = {
  "201": "America/New_York",
  "202": "America/New_York",
  "203": "America/New_York",
  "204": "America/Chicago",
  "205": "America/Chicago",
  "206": "America/Los_Angeles",
  "207": "America/New_York",
  "208": "America/Denver",
  "209": "America/Los_Angeles",
  "210": "America/Chicago",
  "212": "America/New_York",
  "213": "America/Los_Angeles",
  "214": "America/Chicago",
  "215": "America/New_York",
  "216": "America/New_York",
  "217": "America/Chicago",
  "218": "America/Chicago",
  "219": "America/Indiana/Indianapolis",
  "224": "America/Chicago",
  "225": "America/Chicago",
  "226": "America/New_York",
  "228": "America/Chicago",
  "229": "America/New_York",
  "231": "America/Detroit",
  "234": "America/New_York",
  "236": "America/New_York",
  "239": "America/New_York",
  "240": "America/New_York",
  "242": "America/Nassau",
  "246": "America/Barbados",
  "248": "America/Detroit",
  "250": "America/Los_Angeles",
  "251": "America/Chicago",
  "252": "America/New_York",
  "253": "America/Los_Angeles",
  "254": "America/Chicago",
  "256": "America/Chicago",
  "260": "America/Indiana/Indianapolis",
  "262": "America/Chicago",
  "264": "America/Anguilla",
  "267": "America/New_York",
  "268": "America/Antigua",
  "269": "America/Detroit",
  "270": "America/Chicago",
  "276": "America/New_York",
  "278": "America/New_York",
  "281": "America/Chicago",
  "283": "America/New_York",
  "284": "America/Tortola",
  "289": "America/New_York",
  "301": "America/New_York",
  "302": "America/New_York",
  "303": "America/Denver",
  "304": "America/New_York",
  "305": "America/New_York",
  "306": "America/Denver",
  "307": "America/Denver",
  "308": "America/Denver",
  "309": "America/Chicago",
  "310": "America/Los_Angeles",
  "312": "America/Chicago",
  "313": "America/Detroit",
  "314": "America/Chicago",
  "315": "America/New_York",
  "316": "America/Chicago",
  "317": "America/Indiana/Indianapolis",
  "318": "America/Chicago",
  "319": "America/Chicago",
  "320": "America/Chicago",
  "321": "America/New_York",
  "323": "America/Los_Angeles",
  "325": "America/Chicago",
  "330": "America/New_York",
  "331": "America/Chicago",
  "334": "America/Chicago",
  "336": "America/New_York",
  "337": "America/Chicago",
  "339": "America/New_York",
  "340": "America/St_Thomas",
  "345": "America/Cayman",
  "347": "America/New_York",
  "351": "America/New_York",
  "352": "America/New_York",
  "360": "America/Los_Angeles",
  "361": "America/Chicago",
  "369": "America/Los_Angeles",
  "380": "America/New_York",
  "385": "America/Denver",
  "386": "America/New_York",
  "401": "America/New_York",
  "402": "America/Chicago",
  "403": "America/Denver",
  "404": "America/New_York",
  "405": "America/Chicago",
  "406": "America/Denver",
  "407": "America/New_York",
  "408": "America/Los_Angeles",
  "409": "America/Chicago",
  "410": "America/New_York",
  "412": "America/New_York",
  "413": "America/New_York",
  "414": "America/Chicago",
  "415": "America/Los_Angeles",
  "416": "America/New_York",
  "417": "America/Chicago",
  "418": "America/New_York",
  "419": "America/New_York",
  "423": "America/New_York",
  "424": "America/Los_Angeles",
  "425": "America/Los_Angeles",
  "430": "America/Chicago",
  "432": "America/Chicago",
  "434": "America/New_York",
  "435": "America/Denver",
  "438": "America/Denver",
  "440": "America/New_York",
  "441": "Atlantic/Bermuda",
  "442": "America/Los_Angeles",
  "443": "America/New_York",
  "450": "America/New_York",
  "464": "America/Chicago",
  "469": "America/Chicago",
  "470": "America/New_York",
  "473": "America/Grenada",
  "475": "America/New_York",
  "478": "America/New_York",
  "479": "America/Chicago",
  "480": "America/Phoenix",
  "484": "America/New_York",
  "501": "America/Chicago",
  "502": "America/Kentucky/Louisville",
  "503": "America/Los_Angeles",
  "504": "America/Chicago",
  "505": "America/Denver",
  "506": "America/New_York",
  "507": "America/Chicago",
  "508": "America/New_York",
  "509": "America/Los_Angeles",
  "510": "America/Los_Angeles",
  "512": "America/Chicago",
  "513": "America/New_York",
  "514": "America/New_York",
  "515": "America/Chicago",
  "516": "America/New_York",
  "517": "America/Detroit",
  "518": "America/New_York",
  "519": "America/New_York",
  "520": "America/Phoenix",
  "530": "America/Los_Angeles",
  "540": "America/New_York",
  "541": "America/Los_Angeles",
  "551": "America/New_York",
  "557": "America/Chicago",
  "559": "America/Los_Angeles",
  "561": "America/New_York",
  "562": "America/Los_Angeles",
  "563": "America/Chicago",
  "564": "America/Los_Angeles",
  "570": "America/New_York",
  "571": "America/New_York",
  "573": "America/Chicago",
  "574": "America/Indiana/Indianapolis",
  "575": "America/Denver",
  "580": "America/Chicago",
  "585": "America/New_York",
  "586": "America/Detroit",
  "601": "America/Chicago",
  "602": "America/Phoenix",
  "603": "America/New_York",
  "604": "America/Los_Angeles",
  "605": "America/Chicago",
  "606": "America/Kentucky/Louisville",
  "607": "America/New_York",
  "608": "America/Chicago",
  "609": "America/New_York",
  "610": "America/New_York",
  "612": "America/Chicago",
  "613": "America/New_York",
  "614": "America/New_York",
  "615": "America/Chicago",
  "616": "America/New_York",
  "617": "America/New_York",
  "618": "America/Chicago",
  "619": "America/Los_Angeles",
  "620": "America/Chicago",
  "623": "America/Phoenix",
  "626": "America/Los_Angeles",
  "627": "America/Los_Angeles",
  "628": "America/Los_Angeles",
  "630": "America/Chicago",
  "631": "America/New_York",
  "635": "America/New_York",
  "636": "America/Chicago",
  "641": "America/Chicago",
  "646": "America/New_York",
  "647": "America/New_York",
  "649": "America/Grand_Turk",
  "650": "America/Los_Angeles",
  "651": "America/Chicago",
  "660": "America/Chicago",
  "661": "America/Los_Angeles",
  "662": "America/Chicago",
  "664": "America/Montserrat",
  "669": "America/Los_Angeles",
  "670": "Pacific/Saipan",
  "671": "Pacific/Guam",
  "678": "America/New_York",
  "679": "America/New_York",
  "682": "America/Chicago",
  "684": "Pacific/Pago_Pago",
  "689": "America/New_York",
  "701": "America/Chicago",
  "702": "America/Los_Angeles",
  "703": "America/New_York",
  "704": "America/New_York",
  "705": "America/New_York",
  "706": "America/New_York",
  "707": "America/Los_Angeles",
  "708": "America/Chicago",
  "709": "America/New_York",
  "712": "America/Chicago",
  "713": "America/Chicago",
  "714": "America/Los_Angeles",
  "715": "America/Chicago",
  "716": "America/New_York",
  "717": "America/New_York",
  "718": "America/New_York",
  "719": "America/Denver",
  "720": "America/Denver",
  "721": "America/Lower_Princes",
  "724": "America/New_York",
  "727": "America/New_York",
  "731": "America/Chicago",
  "732": "America/New_York",
  "734": "America/Detroit",
  "737": "America/Chicago",
  "740": "America/New_York",
  "747": "America/Los_Angeles",
  "754": "America/New_York",
  "757": "America/New_York",
  "758": "America/St_Lucia",
  "760": "America/Los_Angeles",
  "762": "America/New_York",
  "763": "America/Chicago",
  "764": "America/Los_Angeles",
  "765": "America/New_York",
  "767": "America/Dominica",
  "769": "America/Chicago",
  "770": "America/New_York",
  "772": "America/New_York",
  "773": "America/Chicago",
  "774": "America/New_York",
  "775": "America/Los_Angeles",
  "778": "America/Los_Angeles",
  "779": "America/Chicago",
  "780": "America/Denver",
  "781": "America/New_York",
  "784": "America/St_Vincent",
  "785": "America/Denver",
  "786": "America/New_York",
  "787": "America/Puerto_Rico",
  "800": "America/New_York",
  "801": "America/Denver",
  "802": "America/New_York",
  "803": "America/New_York",
  "804": "America/New_York",
  "805": "America/Los_Angeles",
  "806": "America/Chicago",
  "807": "America/New_York",
  "808": "Pacific/Honolulu",
  "809": "America/Santo_Domingo",
  "810": "America/Detroit",
  "812": "America/Kentucky/Louisville",
  "813": "America/New_York",
  "814": "America/New_York",
  "815": "America/Chicago",
  "816": "America/Chicago",
  "817": "America/Chicago",
  "818": "America/Los_Angeles",
  "819": "America/New_York",
  "828": "America/New_York",
  "829": "America/Santo_Domingo",
  "830": "America/Chicago",
  "831": "America/Los_Angeles",
  "832": "America/Chicago",
  "835": "America/New_York",
  "843": "America/New_York",
  "845": "America/New_York",
  "847": "America/Chicago",
  "848": "America/New_York",
  "849": "America/Santo_Domingo",
  "850": "America/New_York",
  "855": "America/New_York",
  "856": "America/New_York",
  "857": "America/New_York",
  "858": "America/Los_Angeles",
  "859": "America/Kentucky/Louisville",
  "860": "America/New_York",
  "862": "America/New_York",
  "863": "America/New_York",
  "864": "America/New_York",
  "865": "America/New_York",
  "866": "America/New_York",
  "867": "America/New_York",
  "868": "America/Port_of_Spain",
  "869": "America/St_Kitts",
  "870": "America/Chicago",
  "872": "America/Chicago",
  "876": "America/Jamaica",
  "877": "America/New_York",
  "878": "America/New_York",
  "888": "America/New_York",
  "901": "America/Chicago",
  "902": "America/New_York",
  "903": "America/Chicago",
  "904": "America/New_York",
  "905": "America/New_York",
  "906": "America/Detroit",
  "907": "America/Anchorage",
  "908": "America/New_York",
  "909": "America/Los_Angeles",
  "910": "America/New_York",
  "912": "America/New_York",
  "913": "America/Chicago",
  "914": "America/New_York",
  "915": "America/Chicago",
  "916": "America/Los_Angeles",
  "917": "America/New_York",
  "918": "America/Chicago",
  "919": "America/New_York",
  "920": "America/Chicago",
  "925": "America/Los_Angeles",
  "927": "America/New_York",
  "928": "America/Phoenix",
  "931": "America/Chicago",
  "935": "America/Los_Angeles",
  "936": "America/Chicago",
  "937": "America/New_York",
  "939": "America/Puerto_Rico",
  "940": "America/Chicago",
  "941": "America/New_York",
  "947": "America/Detroit",
  "949": "America/Los_Angeles",
  "951": "America/Los_Angeles",
  "952": "America/Chicago",
  "954": "America/New_York",
  "956": "America/Chicago",
  "957": "America/Denver",
  "959": "America/New_York",
  "970": "America/Denver",
  "971": "America/Los_Angeles",
  "972": "America/Chicago",
  "973": "America/New_York",
  "975": "America/Chicago",
  "978": "America/New_York",
  "979": "America/Chicago",
  "980": "America/New_York",
  "984": "America/New_York",
  "985": "America/Chicago",
  "989": "America/Detroit"
}


// Converts America/New_York to -5 for example
export const TimezoneToUtcDiff = (timeZone: string) => {
  const now = new Date();
  const utcTime = now.getTime();
  const localTime = new Date(now.toLocaleString("en-US", { timeZone })).getTime();
  return (localTime - utcTime) / (1000 * 60 * 60); // hours
}

export interface CountryInformation {
  fullName: string;
  alphaCode: string;
  dialCode: string;
  timeZone: string;
  timeZoneUTCDiff: number
  regions: COUNTRY_REGION_ENUM_TYPE[];
}

export const COUNTRY_LIST: CountryInformation[] = Object.entries(COUNTRY_NAMES).map(([alphaCode, fullName]) => {
  const dialCode = COUNTRY_PHONE_CODES[alphaCode as keyof typeof COUNTRY_PHONE_CODES];
  const timeZone = COUNTRY_PHONE_TO_TIMEZONE[alphaCode as keyof typeof COUNTRY_PHONE_TO_TIMEZONE];
  const timeZoneUTCDiff = TimezoneToUtcDiff(timeZone);
  const regions = COUNTRY_TO_REGION_MAP[alphaCode as keyof typeof COUNTRY_TO_REGION_MAP];
  return {
    fullName,
    alphaCode,
    dialCode,
    timeZone,
    timeZoneUTCDiff,
    regions: regions ?? []
  }
})

const COUNTRY_CODE_TO_INDEX_MAP: Record<string, number> = COUNTRY_LIST.reduce((acc, country, index) => {
  acc[country.alphaCode] = index;
  return acc;
}, {} as Record<string, number>);

export const getCountryInformation = (alphaCode: string): CountryInformation => {
  if (!COUNTRY_CODE_TO_INDEX_MAP[alphaCode]) {
    throw new Error(`Country code ${alphaCode} not found`);
  }
  const res = COUNTRY_LIST[COUNTRY_CODE_TO_INDEX_MAP[alphaCode]];
  if (!res) {
    throw new Error(`Country code ${alphaCode} not found`);
  }
  return res;
}

export const getCountryInformationByPhone = (phoneNumber: string) => {
  // phone numbers - might contain +44, or just start with it, might have space, might not..
  const cleaned = phoneNumber.replace(/\D/g, '');
  // Try match, longest match
  let countryCode = null;
  for (let length = 4; length >= 1; length--) {
    const prefix = cleaned.substring(0, length);
    if (countryPhoneCodeInversed[prefix]) {
      countryCode = countryPhoneCodeInversed[prefix];
      break;
    }
  }
  if (!countryCode) {
    throw new Error(`Country code not found for phone number ${phoneNumber}`);
  }
  const clonedCountryInfo: CountryInformation = { ...getCountryInformation(countryCode) };
  if (countryCode === 'US') {
    // For US - we can adjust timezone to depend on area code too
    const areaCode = cleaned.substring(1, 4);
    if (US_AREA_CODE_TIMEZONES[areaCode as keyof typeof US_AREA_CODE_TIMEZONES]) {
      const area = US_AREA_CODE_TIMEZONES[areaCode as keyof typeof US_AREA_CODE_TIMEZONES];
      clonedCountryInfo.timeZone = area;
      clonedCountryInfo.timeZoneUTCDiff = TimezoneToUtcDiff(clonedCountryInfo.timeZone);
    }
  }
  return clonedCountryInfo;
}

// Lowercase version of COUNTRY_NAMES for backward compatibility with existing code
export const COUNTRY_CODE_TO_NAME_MAP: Record<string, string> = Object.fromEntries(
  Object.entries(COUNTRY_NAMES).map(([code, name]) => [code.toLowerCase(), name])
);

// Reverse mapping: region to countries
export const REGION_TO_COUNTRIES_MAP: Record<COUNTRY_REGION_ENUM_TYPE, string[]> = {
  all: Object.keys(COUNTRY_TO_REGION_MAP),
  africa: Object.keys(COUNTRY_TO_REGION_MAP).filter(code =>
    COUNTRY_TO_REGION_MAP[code]?.includes('africa') ?? false),
  asia: Object.keys(COUNTRY_TO_REGION_MAP).filter(code =>
    COUNTRY_TO_REGION_MAP[code]?.includes('asia') ?? false),
  europe: Object.keys(COUNTRY_TO_REGION_MAP).filter(code =>
    COUNTRY_TO_REGION_MAP[code]?.includes('europe') ?? false),
  north_america: Object.keys(COUNTRY_TO_REGION_MAP).filter(code =>
    COUNTRY_TO_REGION_MAP[code]?.includes('north_america') ?? false),
  south_america: Object.keys(COUNTRY_TO_REGION_MAP).filter(code =>
    COUNTRY_TO_REGION_MAP[code]?.includes('south_america') ?? false),
  oceania: Object.keys(COUNTRY_TO_REGION_MAP).filter(code =>
    COUNTRY_TO_REGION_MAP[code]?.includes('oceania') ?? false),
  middle_east: Object.keys(COUNTRY_TO_REGION_MAP).filter(code =>
    COUNTRY_TO_REGION_MAP[code]?.includes('middle_east') ?? false),
  caribbean: Object.keys(COUNTRY_TO_REGION_MAP).filter(code =>
    COUNTRY_TO_REGION_MAP[code]?.includes('caribbean') ?? false),
  eu_citizens: Object.keys(COUNTRY_TO_REGION_MAP).filter(code =>
    COUNTRY_TO_REGION_MAP[code]?.includes('eu_citizens') ?? false),
  commonwealth: Object.keys(COUNTRY_TO_REGION_MAP).filter(code =>
    COUNTRY_TO_REGION_MAP[code]?.includes('commonwealth') ?? false),
  developing_countries: Object.keys(COUNTRY_TO_REGION_MAP).filter(code =>
    COUNTRY_TO_REGION_MAP[code]?.includes('developing_countries') ?? false),
};

/**
 * Get regions for a country code
 */
export function getRegionsForCountry(countryCode: string): COUNTRY_REGION_ENUM_TYPE[] {
  return COUNTRY_TO_REGION_MAP[countryCode.toLowerCase()] || [];
}

/**
 * Get countries for a region
 */
export function getCountriesForRegion(region: COUNTRY_REGION_ENUM_TYPE): string[] {
  return REGION_TO_COUNTRIES_MAP[region] || [];
}

/**
 * Check if a country belongs to a specific region
 */
export function isCountryInRegion(countryCode: string, region: COUNTRY_REGION_ENUM_TYPE): boolean {
  return getRegionsForCountry(countryCode).includes(region);
}